import { useState, useEffect, useRef } from "react";
import { Input, Typography, Flex, Alert } from "antd";
import CustomButton from "../../components/CustomButton/Button";
import ArrowLeftIcon from "../../assets/icons/arrow-left.svg";
import { useDispatch, useSelector } from "react-redux";
import {
    validateOtp,
    getInvestorDetailsByOrgId,
    editValidateOtp,
} from "../../redux/slices/ProfileSlice";
import { getUserDetails } from "../../redux/slices/AuthSlice";
import "./OtpContent.scss";
import { BTN_TXT, DESC_TXT } from "../../constants/constants";

const { Title, Text } = Typography;

const numberOfDigits = 6;

const OtpContent = ({
    onClose,
    oldDetailOtpModalOpen,
    setNewDetailModalOpen,
    newDetailOtpModalOpen,
    newDetail,
    setNewDetail,
    isMobileOtp,
    oldDetail
}) => {
    const [otp, setOtp] = useState(new Array(numberOfDigits).fill(""));
    const [seconds, setSeconds] = useState(60);
    const [isResendEnabled, setIsResendEnabled] = useState(false);
    const otpBoxReference = useRef([]);
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const {
        otpData,
        error,
        editValidateOtpError,
        validateOtpLoading,
    } = useSelector((state) => state.profile);

    const otpAlertMessage = newDetail ? editValidateOtpError : error;

    const isOtpFilled = otp.every((digit) => digit !== "");

    useEffect(() => {
        if (oldDetailOtpModalOpen || newDetailOtpModalOpen) {
            setOtp(new Array(numberOfDigits).fill(""));
            setSeconds(60);
            setIsResendEnabled(false);
        }
    }, [oldDetailOtpModalOpen, newDetailOtpModalOpen]);

    useEffect(() => {
        if (seconds > 0) {
            const timerId = setTimeout(() => setSeconds(seconds - 1), 1000);
            return () => clearTimeout(timerId);
        } else {
            setIsResendEnabled(true);
        }
    }, [seconds]);

    const backToChangeDetail = () => {
        onClose();
        setNewDetailModalOpen(true);
    };

    const handleResendOtp = () => {
        setOtp(new Array(numberOfDigits).fill(""));
        setSeconds(60);
        setIsResendEnabled(false);
    };

    const handleChange = (value, index) => {
        let newArr = [...otp];
        newArr[index] = value;
        setOtp(newArr);

        if (value && index < numberOfDigits - 1) {
            otpBoxReference.current[index + 1].focus();
        }
    };

    const handleBackspaceAndEnter = (e, index) => {
        if (e.key === "Backspace" && !e.target.value && index > 0) {
            otpBoxReference.current[index - 1].focus();
        }
        if (e.key === "Enter" && e.target.value && index < numberOfDigits - 1) {
            otpBoxReference.current[index + 1].focus();
        }
    };

    const handleVerifyOtp = async () => {
        const otpString = otp.join("");

        const payload = {
            email: newDetail ? newDetail : oldDetail,
            otp: otpString,
            reqId: otpData?.response?.reqId,
            docId: otpData?.response?.docId,
            orgId: user?.orgId,
        }

        if (isMobileOtp) {
            delete payload.email
            payload.mobile = newDetail ? newDetail : oldDetail
        }

        const response = await dispatch(newDetail ? editValidateOtp(payload) : validateOtp(payload))

        if (response.payload.statusCode === 201) {
            onClose();
            setOtp(new Array(numberOfDigits).fill(""));
            if (newDetail) {
                setNewDetail(null);
                dispatch(getInvestorDetailsByOrgId(user?.orgId));
                dispatch(getUserDetails());
            } else {
                setNewDetailModalOpen(true);
            }
        }

    };

    return (
        <div className="otp-content-container">
            {newDetailOtpModalOpen && (
                <img
                    src={ArrowLeftIcon}
                    alt="Arrow-left"
                    className="back-arrow"
                    onClick={backToChangeDetail}
                />
            )}
            <Title level={3}>Verify OTP</Title>
            <Text style={{ fontSize: 14, textAlign: "center" }}>
                {newDetail
                    ? `We have sent a 6-digit OTP to ${newDetail}. Please check your ${isMobileOtp ? "phone" : "email"}.`
                    : `Please enter the OTP sent to your registered ${isMobileOtp ? "phone number" : "email"} to confirm it's really you.`
                }
            </Text>
            <Flex
                align="center"
                justify="space-between"
                style={{ marginTop: 70, width: "100%" }}
            >
                {otp.map((digit, index) => (
                    <Input
                        key={index}
                        value={digit}
                        onChange={(e) => handleChange(e.target.value, index)}
                        onKeyUp={(e) => handleBackspaceAndEnter(e, index)}
                        ref={(reference) => (otpBoxReference.current[index] = reference)}
                        style={{ textAlign: "center", width: 50.6 }}
                        maxLength={1}
                    />
                ))}
            </Flex>
            {otpAlertMessage && (
                <Alert style={{ marginTop: 20 }} message={otpAlertMessage} type="error" showIcon />
            )}
            <CustomButton
                type="primary"
                block
                onClick={handleVerifyOtp}
                disabled={!isOtpFilled}
                loading={validateOtpLoading}
                className="otp-submit-btn"
            >
                {BTN_TXT.VERIFY_OTP}
            </CustomButton>

            {isResendEnabled ? (
                <Text onClick={handleResendOtp} style={{ cursor: "pointer" }}>
                    {BTN_TXT.RESEND_OTP}
                </Text>
            ) : (
                <Text>
                    Resends in {seconds} {seconds === 1 ? "second" : "seconds"}
                </Text>
            )}
            {!isMobileOtp && (
                <Text style={{ color: "#40566D", marginTop: 20, fontSize: 12, textAlign: "center" }}>
                    {DESC_TXT.OTP_INFO_TEXT}
                </Text>
            )}
        </div>
    );
};

export default OtpContent;
